import React, { useState, useEffect, useRef } from 'react';
import styled from '@emotion/styled';
import { css } from 'emotion';

import { Row, Col, Collapse, Card, CardBody } from 'reactstrap';

function TopModuleMobileTile(props) {

  const renderContent = (content) => {
    return { __html: content };
  }
  const [isOpen, setIsOpen] = useState(false);
  const [border, setBorder] = useState(false);
  const scrollToRef = (ref) => window.scrollTo(0, ref.current.offsetTop)
  // const scrollToRef = (ref) => window.scrollTo(0, ref.current.offsetTop)
  const tileRef  = useRef(props.index)

  // useEffect(() => {
  //   if (localStorage.getItem('activeTopModuleTile')) {
  //     if (props.index == localStorage.getItem('activeTopModuleTile')) {
  //       toggle()
  //     }
  //   }
  // }, []);

  const toggle = () => {

    setIsOpen(!isOpen);
    if (isOpen) {
      setBorder(false);
     // localStorage.removeItem('activeTopModuleTile');
    }
    else {
      setBorder(true);
      for (var i = 1; i <= props.tileLength; i++) {
        if (document.getElementById("closeIcon" + i) && props.index != i) {
          document.getElementById("closeIcon" + i).click();
        }
      }
      //scrollToRef(tileRef);
     // localStorage.setItem('activeTopModuleTile', props.index);

    }

  }


  const list = () => {
    return (props.parentContentArray.map((sub, subindex) =>
      ((sub.filepath != props.tile.filepath) && (sub.filepath.indexOf(props.tile.filepath) > -1)) ?
        (props.parentContentArray.length -1 == subindex) ? <li ref={tileRef} key={subindex}><a href={sub.filepath}>{sub.displayname}</a></li> :<li key={subindex}><a href={sub.filepath}>{sub.displayname}</a></li> : ''
    ))
  }

  const hasList = () => {
    var arr = list();
    for (var i = 0; i < arr.length; i++) {
      if (arr[i] !== "") return true;
    }
    return false;
  }

  return (

    <div className='top-module-mobile-tile '>
      <Card  onClick={(hasList() && (isOpen == false) && (!props.tile.isParent) ) ? toggle : null} className={"three_six_card " + (css`background-color: ${props.module.MobileTileBackgroundColor}!important; border:${(border) ? '2px solid ' + props.module.MobileTileFocusColor + ' !important' : ''}; &:hover, &:focus, &:focus-within, &:active {background-color:  ${!(hasList()) ? props.module.MobileTileBackgroundColorHover : ''}!important;}`)} >
      <a aria-label={props.tile.ariaLabel || undefined} href={(!hasList() || (props.tile.isParent)) ? props.tile.filepath : null}>
          <Row className="d-flex align-items-center p-4 col-12" >
            <Col className="col-9">
              <p className={"ml-2 " + (css`color: ${props.module.MobileTileFontColor}!important; &:hover, &:focus, &:focus-within, &:active {color: ${!(hasList()) ? props.module.MobileTileFontColorHover : ''}!important;}`)}  >{props.tile.displayname}</p>
            </Col>
            {props.tile.displayicon &&
              <Col className="col-3">
                <img className="mobile-tile-icon" src={props.tile.displayicon}></img>
              </Col>
            }
            {hasList() && isOpen &&
              <img id={"closeIcon" + props.index} onClick={toggle} src={props.module.CloseIcon ? props.module.CloseIcon.path : ''} alt="Close" className="card-body-close-icon" />
            }
          </Row>
          {hasList() && (!props.tile.isParent) &&
            <Collapse isOpen={isOpen}>
              <CardBody>
                <hr className={"mt-0 " + (css`border: 1px solid ${props.module.MobileTileFocusColor}!important;}`)} />
                <ul className="ml-2  card-list">
                  {list()}
                </ul>
              </CardBody>
            </Collapse>
          }
       </a>
      </Card>
    </div>

  )
}
export default TopModuleMobileTile;